import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';


const setPropertyFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};
const clearPropertyFormData = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_PROPERTY_FORM_DATA]: setPropertyFormData,
  [TYPES.CLEAR_PROPERTY_FORM_DATA]:clearPropertyFormData
});
